import { ReactElement, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { DEFAULT_COMPONENTS } from './helpers';

export const Translate = ({
  i18nKey,
  components,
  values,
}: {
  i18nKey: string;
  components?: Record<string, ReactElement>;
  values?: Record<string, string | number | undefined | ReactNode>;
}) => {
  const { t } = useTranslation();

  return <Trans t={t} i18nKey={i18nKey} components={{ ...DEFAULT_COMPONENTS, ...components }} values={values} />;
};
